import { getApiErrorMessage } from '@shared/api/client'

/** Тексты `detail`, как их шлёт бэк (с опечаткой «исполненна»): машинного кода в ответе нет. */
export const MODERATION_DETAIL = {
  stale: 'Location request is outdated or inconsistent.',
  resolved: 'Данная заявка уже была исполненна.',
} as const

export const ModerationErrorKind = {
  /** Профиль участника изменился после заявки: одобрить нельзя, можно отклонить. */
  stale: 'stale',
  /** Заявку уже обработали (кто и как — неизвестно). */
  resolved: 'resolved',
  other: 'other',
} as const
export type ModerationErrorKind = (typeof ModerationErrorKind)[keyof typeof ModerationErrorKind]

export function classifyModerationError(error: unknown): ModerationErrorKind {
  const detail = getApiErrorMessage(error)?.trim()
  if (detail === MODERATION_DETAIL.stale) return ModerationErrorKind.stale
  if (detail === MODERATION_DETAIL.resolved) return ModerationErrorKind.resolved
  return ModerationErrorKind.other
}

export function isKnownModerationError(error: unknown): boolean {
  return classifyModerationError(error) !== ModerationErrorKind.other
}
